
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wiki/languages/[slug]",
      function () {
        return require("private-next-pages/wiki/languages/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wiki/languages/[slug]"])
      });
    }
  